import { useQuery } from "@tanstack/react-query";
import axios from "const/axios";
import { API_URL } from "const/constants";
import { moduleInvoiceQueryKey } from "components/ModulePayments/moduleFinanceQueries";

const baseUrl = (moduleType, moduleId) => `${API_URL}/module-invoices/${moduleType}/${moduleId}`;
const dataOf = (response) => response.data?.data;

export const fetchModuleInvoice = (moduleType, moduleId) =>
  axios.get(baseUrl(moduleType, moduleId)).then(dataOf);

export const fetchModuleInvoiceDraft = (moduleType, moduleId) =>
  axios.get(`${baseUrl(moduleType, moduleId)}/draft`).then(dataOf);

export const createModuleInvoice = (moduleType, moduleId, body) =>
  axios.post(baseUrl(moduleType, moduleId), body).then(dataOf);

export const updateModuleInvoice = (moduleType, moduleId, body) =>
  axios.put(baseUrl(moduleType, moduleId), body).then(dataOf);

export const syncModuleInvoiceCharges = (moduleType, moduleId) =>
  axios.post(`${baseUrl(moduleType, moduleId)}/sync-charges`).then(dataOf);

export const deleteModuleInvoice = (moduleType, moduleId) =>
  axios.delete(baseUrl(moduleType, moduleId));

export const useModuleInvoice = (moduleType, moduleId, options = {}) =>
  useQuery({
    queryKey: moduleInvoiceQueryKey(moduleType, moduleId),
    queryFn: () => fetchModuleInvoice(moduleType, moduleId),
    enabled: Boolean(moduleType && moduleId),
    refetchOnMount: "always",
    refetchOnWindowFocus: false,
    retry: false,
    ...options,
  });
